import { VideoCameraFrontOutlined, Brush } from '@mui/icons-material';
import { Avatar, Box, Typography } from '@mui/material';
import { useAuthorAStyles } from './author-avatar.styles';

const AuthorAvatar = ({ size, author, icon, date }) => {
  const classes = useAuthorAStyles();

  const getIcon = (icon, classes) => {
    switch (icon) {
      case 'video':
        return [<VideoCameraFrontOutlined />, classes.videoIcon];

      case 'blog':
        return [<Brush />, classes.blogIcon];

      default:
    }
  };

  return (
    <Box display='flex' alignItems='center'>
      <Avatar
        sx={{ width: 64, height: 64, marginRight: 2 }}
        className={getIcon(icon, classes)[1]}
        alt=''
      >
        {getIcon(icon, classes)[0]}
      </Avatar>
      <Box>
        <Typography className={classes.aaName}>{author}</Typography>
        <Typography className={classes.aaDate}>{date}</Typography>
      </Box>
    </Box>
  );
};

export default AuthorAvatar;
